// eslint-disable-next-line jira/filename-case
import React, { type ComponentType } from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { LegacyTeamProfileCardBaseProps } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LegacyTeamProfileCard = lazy(
	() => import(/* webpackChunkName: "async-legacy-team-profile-card" */ './index.tsx'),
);

export const AsyncLegacyTeamProfileCard: ComponentType<LegacyTeamProfileCardBaseProps> = (
	props: LegacyTeamProfileCardBaseProps,
) => (
	<JSErrorBoundary id="legacy-team-profile-card" packageName="profilecard-next">
		<Placeholder name="async-legacy-team-profile-card" fallback={null}>
			<LegacyTeamProfileCard {...props} />
		</Placeholder>
	</JSErrorBoundary>
);

export default AsyncLegacyTeamProfileCard;
